// components/ConnectionPreview.tsx
import React from "react";
import { Box } from "@mui/material";

interface ConnectionPreviewProps {
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
  color: string;
}

const ConnectionPreview: React.FC<ConnectionPreviewProps> = ({
  fromX,
  fromY,
  toX,
  toY,
  color,
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        left: 0,
        top: 0,
        pointerEvents: "none",
        zIndex: 998,
        width: "100%",
        height: "100%",
      }}
    >
      <svg
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          overflow: "visible",
        }}
      >
        <defs>
          <marker
            id={`arrowhead-${color.replace("#", "")}`}
            markerWidth="10"
            markerHeight="7"
            refX="10"
            refY="3.5"
            orient="auto"
          >
            <polygon points="0 0, 10 3.5, 0 7" fill={color} opacity={0.7} />
          </marker>
        </defs>
        <path
          fill="none"
          stroke={color}
          strokeWidth={3}
          strokeDasharray="8,4"
          strokeOpacity={0.7}
          markerEnd={`url(#arrowhead-${color.replace("#", "")})`}
          d={`M${fromX},${fromY} C ${fromX + (toX - fromX) / 2} ${fromY} ${
            fromX + (toX - fromX) / 2
          } ${toY} ${toX},${toY}`}
        />
        <circle cx={fromX} cy={fromY} fill={color} r={4} opacity={0.7} />
      </svg>
    </Box>
  );
};

export default ConnectionPreview;
